import type { DigitNumber } from "../types.ts";

/**
 * Checks if a character is a digit.
 *
 * @param code the character to check
 * @returns check result
 */
export const isDigit = (code: number): code is DigitNumber => {
  return code >= 48 && code <= 57; // 0..9
};
